package features.watch.data

import features.watch.model.WatchEntry
import features.watch.model.WatchSyncBody
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.post
import io.ktor.client.request.setBody

class WatchProgressRepository(
    private val httpClient: HttpClient,
) {
    suspend fun sync(items: List<WatchEntry>, language: String = ""): List<WatchEntry> {
        return httpClient.post("watch/sync") {
            setBody(WatchSyncBody(items = items, language = language))
        }.body()
    }
}
